export default "__VITE_ASSET__CqwVZJ1G__"